import React from 'react';
import ReactInfiniteScroll from 'react-infinite-scroller';
import { Consumer } from './ScrollRootContext';

const InfiniteScroll = ({ children, ...props }) => (
    <Consumer>
        {ref => (
            <ReactInfiniteScroll {...props} useWindow={ref.current === window} getScrollParent={() => ref.current}>
                {children}
            </ReactInfiniteScroll>
        )}
    </Consumer>
);

export default InfiniteScroll;
